import { useMutation } from "@apollo/client";

import { MUTATION_RECORD_BROKER_CONSENT } from "api/mutations/cases";
import ConfirmDialog from "pages/CaseDetail/components/ConfirmDialog";
import {
  ConsentAction,
  PendingAction,
} from "pages/CaseDetail/components/Tasks/types";
import useLastDefined from "pages/CaseDetail/hooks/useLastDefined";

interface ConsentTaskDialogProps {
  caseId: string;
  pending?: PendingAction<ConsentAction>;
  onClose: () => void;
  onCompleted: () => void;
}

const ConsentTaskDialog = ({
  caseId,
  pending,
  onClose,
  onCompleted,
}: ConsentTaskDialogProps) => {
  const shown = useLastDefined(pending);

  // Recording consent closes the case's broker consent task on the backend.
  const [recordConsent, { loading, error, reset }] = useMutation(
    MUTATION_RECORD_BROKER_CONSENT,
    { onCompleted: () => onCompleted() },
  );

  return (
    <ConfirmDialog
      open={!!pending}
      onClose={onClose}
      afterLeave={reset}
      onConfirm={() =>
        recordConsent({ variables: { caseUuid: caseId } }).catch(() => {})
      }
      loading={loading}
      error={!!error}
      title={shown?.task.title ?? ""}
      confirmLabel={shown?.action.label ?? ""}
    >
      <p>{shown?.action.confirmText}</p>
    </ConfirmDialog>
  );
};

export default ConsentTaskDialog;
